import React from 'react'
import { Layout } from 'antd'
// import { Header, Sider } from '../common/'
import { Sider } from '../common/'
import Header from '../common/header'
import { HomeRoutes } from '../Route'

import Universal from '../universal/Universal'

const { Content } = Layout

const HomeLayout = (props) => {
  return(
    <Universal>
    <Layout>
      <Header />
      <Layout className="ant-layout-has-sider">
        <Sider {...props} />
        <Layout style={{padding: 20}}>
          <Content>
            <HomeRoutes />
          </Content>
        </Layout>
      </Layout>
    </Layout>
    </Universal>
  )
}

export default HomeLayout



// WEBPACK FOOTER //
// ./src/layout/HomeLayout.js